module.exports = __webpack_public_path__ + "img/croatia.5dd7d5b2.svg";